// assets
import { DashboardOutlined, RobotOutlined } from "@ant-design/icons";

import { NavItemType } from "@/types/menu";

// ==============================|| MENU ITEMS - ACCOUNT ||============================== //
//
// The "ACCOUNT" section title and the static account (company) card are rendered in
// DrawerContent above the navigation — this group holds only the account-scoped
// navigation items, so it carries no `title` of its own.

const account: NavItemType = {
  id: "group-account",
  type: "group",
  children: [
    {
      id: "agents",
      title: "Agents",
      type: "item",
      url: "/agents",
      icon: RobotOutlined,
    },
    {
      id: "brand-visibility",
      title: "Brand Visibility",
      type: "item",
      url: "/brand-visibility",
      icon: DashboardOutlined,
    },
  ],
};

export default account;
